// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.review-section {
    padding: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24px;
    background: linear-gradient(to right, #ECF2FF, #FBFCFF);
}
/* Text */
.rw-text-content {
    width: 100%;
}
.rw-text-title {
    margin: 16px 0;
    color: #6F7074;
    font-family: 'Inter', sans-serif;
    font-size: 32px;
    font-weight: bold;
    letter-spacing: .7px;
}
.rw-text-num {
    color: #2e5288;
}
.rw-text-desc {
    margin: 16px 0;
    color: black;
    font-family: 'Inter', sans-serif;
    font-size: 36px;
    font-weight: bold;
    letter-spacing: .7px;
    line-height: 2.6rem;
}
.rw-text-format {
    margin: 64px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
}
.rw-text-quote1 {
    position: absolute;
    top: -18px;
    left: -24px;
    color: #2e5288;
    font-family: 'Inter', sans-serif;
    font-size: 40px;
    font-weight: bold;
    letter-spacing: 2px;
}
.rw-text-quote2 {
    position: absolute;
    right: -18px;
    bottom: -24px;
    color: #2e5288;
    font-family: 'Inter', sans-serif;
    font-size: 40px;
    font-weight: bold;
    letter-spacing: 2px;
}
.rw-review {
    display: block;
    margin: 0 0 0 8px;
    color: black;
    font-family: 'Inter', sans-serif;
    font-size: 24px;
    letter-spacing: .7px;
    line-height: 2.2rem;
}
.rw-authors {
    margin: 0 0 0 8px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
}
.rw-reviewer-name {
    font-family: 'Inter', sans-serif;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: .8px;
}
.rw-reviewer-place {
    margin: 6px 0 0 0;
    color: #6F7074;
    font-family: 'Inter', sans-serif;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: .8px;
}
/* Buttons */
.rw-next-btn {
    margin: 0 24px 0 0;
    color: black;
    border: 1px solid transparent;
    background-color: transparent;
    outline: transparent;
    font-size: 48px;
    cursor: pointer;
}
.rw-next-btn:hover {
    color: #2e5288;
}
/* Responsive */
@media screen and (max-width: 700px) {
    .review-section {
        letter-spacing: .8px;
    }
    .rw-text-title {
        font-size: 22px;
    }
    .rw-text-desc {
        font-size: 28px;
    }
    .rw-review {
        font-size: 22px;
        letter-spacing: .7px;
        line-height: 1.8rem;
    }
    .rw-reviewer-name {
        font-size: 20px;
    }
    .rw-next-btn {
        margin: 0 16px 0 0;
        font-size: 40px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/Reviews.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,uDAAuD;AAC3D;AACA,SAAS;AACT;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,YAAY;IACZ,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,gCAAgC;IAChC,eAAe;IACf,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;AACA,YAAY;AACZ;IACI,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,6BAA6B;IAC7B,oBAAoB;IACpB,eAAe;IACf,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA,eAAe;AACf;IACI;QACI,oBAAoB;IACxB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,oBAAoB;QACpB,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,eAAe;IACnB;AACJ","sourcesContent":[".review-section {\n    padding: 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 24px;\n    background: linear-gradient(to right, #ECF2FF, #FBFCFF);\n}\n/* Text */\n.rw-text-content {\n    width: 100%;\n}\n.rw-text-title {\n    margin: 16px 0;\n    color: #6F7074;\n    font-family: 'Inter', sans-serif;\n    font-size: 32px;\n    font-weight: bold;\n    letter-spacing: .7px;\n}\n.rw-text-num {\n    color: #2e5288;\n}\n.rw-text-desc {\n    margin: 16px 0;\n    color: black;\n    font-family: 'Inter', sans-serif;\n    font-size: 36px;\n    font-weight: bold;\n    letter-spacing: .7px;\n    line-height: 2.6rem;\n}\n.rw-text-format {\n    margin: 64px 0;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    position: relative;\n}\n.rw-text-quote1 {\n    position: absolute;\n    top: -18px;\n    left: -24px;\n    color: #2e5288;\n    font-family: 'Inter', sans-serif;\n    font-size: 40px;\n    font-weight: bold;\n    letter-spacing: 2px;\n}\n.rw-text-quote2 {\n    position: absolute;\n    right: -18px;\n    bottom: -24px;\n    color: #2e5288;\n    font-family: 'Inter', sans-serif;\n    font-size: 40px;\n    font-weight: bold;\n    letter-spacing: 2px;\n}\n.rw-review {\n    display: block;\n    margin: 0 0 0 8px;\n    color: black;\n    font-family: 'Inter', sans-serif;\n    font-size: 24px;\n    letter-spacing: .7px;\n    line-height: 2.2rem;\n}\n.rw-authors {\n    margin: 0 0 0 8px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n}\n.rw-reviewer-name {\n    font-family: 'Inter', sans-serif;\n    font-size: 24px;\n    font-weight: bold;\n    letter-spacing: .8px;\n}\n.rw-reviewer-place {\n    margin: 6px 0 0 0;\n    color: #6F7074;\n    font-family: 'Inter', sans-serif;\n    font-size: 18px;\n    font-weight: bold;\n    letter-spacing: .8px;\n}\n/* Buttons */\n.rw-next-btn {\n    margin: 0 24px 0 0;\n    color: black;\n    border: 1px solid transparent;\n    background-color: transparent;\n    outline: transparent;\n    font-size: 48px;\n    cursor: pointer;\n}\n.rw-next-btn:hover {\n    color: #2e5288;\n}\n/* Responsive */\n@media screen and (max-width: 700px) {\n    .review-section {\n        letter-spacing: .8px;\n    }\n    .rw-text-title {\n        font-size: 22px;\n    }\n    .rw-text-desc {\n        font-size: 28px;\n    }\n    .rw-review {\n        font-size: 22px;\n        letter-spacing: .7px;\n        line-height: 1.8rem;\n    }\n    .rw-reviewer-name {\n        font-size: 20px;\n    }\n    .rw-next-btn {\n        margin: 0 16px 0 0;\n        font-size: 40px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
